import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { T4coreModule, AuthGuard, SystemRights } from 't4core';
import { T4CommonModule } from '../../t4common/t4common';
import { ServiceModule } from '../Service/service.module';
import { T4_EditObjectDialog } from './dialogs/EditObjectDialog/editObjectDialog';
import { HomeComponent } from './views/home/home.component';
import { ObjectsComponent } from './views/objects/objects.component';
import { OneWayFleetComponent } from './views/oneway/oneway.component';
import { ServiceComponent } from './views/Service/Service';
import { InsuranceCasesComponent } from './views/InsuranceCasesComponent/InsuranceCasesComponent';
import { ClaimCasesComponent } from './views/ClaimCasesComponent/ClaimCasesComponent';
import { ClaimStatisticsComponent } from './views/ClaimStatistics/ClaimStatistics';
import { CreateObjectDialog } from './dialogs/CreateObjectDialog/CreateObjectDialog';
import { LocksComponent } from './views/locks/locks.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { T4FleetChartWidget } from './widgets/fleet-chart/fleet-chart';
import { NotesTableComponent } from './views/Notes/notes';
import { StolenTableComponent } from './views/StolenTrailers/StolenTrailers';
import { ConnectLockDialog } from './dialogs/ConnectLockDialog/ConnectLockDialog';


@NgModule({
    declarations: [
        HomeComponent,
        ObjectsComponent,
        OneWayFleetComponent,
        ServiceComponent,
        T4_EditObjectDialog,
        InsuranceCasesComponent,
        ClaimCasesComponent,
        ClaimStatisticsComponent,
        CreateObjectDialog,
        LocksComponent,
        T4FleetChartWidget,
        NotesTableComponent,
        StolenTableComponent,
        ConnectLockDialog
    ],
    imports: [
        T4CommonModule,
        T4coreModule,
        ServiceModule,
        DragDropModule,
        RouterModule.forChild([
            {
                path: 'Fleet',
                canActivate: [AuthGuard],
                data: { index: 9, title: "Fleet", toolTip: "Manage your rental fleet", roles: ['Clerk', 'LocationManager', 'OneWayAdmin', 'GroupManager'], icon: 'local_shipping' },
                children: [
                    { path: '', redirectTo: 'Dashboard', pathMatch: 'full' },
                    {
                        path: "Dashboard",
                        canActivate: [AuthGuard],
                        component: HomeComponent,
                        data: { title: "Dashboard", toolTip: "Dashboard", roles: ['LocationManager', 'OneWayAdmin', 'GroupManager'], icon: 'bar_chart' }
                    },
                    {
                        path: "Objects",
                        canActivate: [AuthGuard],
                        component: ObjectsComponent,
                        data: { title: "Rental objects", toolTip: "My rental objects", roles: ['Clerk', 'LocationManager', 'GroupManager'], icon: 'local_shipping' }
                    },
                    {
                        path: "OneWay",
                        canActivate: [AuthGuard],
                        component: OneWayFleetComponent,
                        data: { title: "OneWay", toolTip: "OneWay", roles: ['OneWayAdmin', 'Clerk', 'LocationManager', 'GroupManager'], icon: 'rv_hookup', requireOneWay: true }
                    },
                    {
                        path: "Issues",
                        canActivate: [AuthGuard],
                        component: ServiceComponent,
                        data: { title: "Issues", toolTip: "Issues on my fleet", roles: ['Clerk', 'LocationManager', 'GroupManager', 'OneWayAdmin'], icon: 'warning' }
                    },
                    {
                        path: "InsuranceCases",
                        canActivate: [AuthGuard],
                        component: InsuranceCasesComponent,
                        data: { title: "Insurance cases", toolTip: "Insurance cases for my fleet", roles: ['Clerk', 'LocationManager', 'GroupManager', 'Backoffice'], icon: 'article' }
                  },
                  {
                    path: "Claims",
                    canActivate: [AuthGuard],
                    data: { title: "Claims", toolTip: "Claims for my fleet", roles: ['Clerk', 'LocationManager', 'GroupManager', 'Backoffice'], icon: 'gavel' },
                    children: [
                      { path: '', redirectTo: 'List', pathMatch: 'full' },
                      {
                        path: "List",
                        canActivate: [AuthGuard],
                        component: ClaimCasesComponent,
                        data: { title: "Claims", toolTip: "Claims for my fleet", roles: ['Clerk', 'LocationManager', 'GroupManager', 'Backoffice'], icon: 'gavel' },
                      },
                      {
                        path: "ClaimStatistics",
                        canActivate: [AuthGuard],
                        component: ClaimStatisticsComponent,
                        data: { title: "Statistics", toolTip: "Claim statistics", roles: ['Backoffice'], icon: 'bar_chart' }
                      }
                    ]
                  },
                  
                  {
                    path: "Notes",
                    canActivate: [AuthGuard],
                    component: NotesTableComponent,
                    data: { title: "Notes", toolTip: "Active Notes", roles: ['Clerk', 'LocationManager', 'GroupManager', 'Backoffice'], icon: 'article' }
                  },
                  {
                    path: "StolenIssues",
                    canActivate: [AuthGuard],
                    component: StolenTableComponent,
                    data: { title: "Stolen trailer cases", toolTip: "Stolen Notes", roles: ['Backoffice'], icon: 'article' }
                  }                //,
                    //{
                    //  path: "Locks",
                    //  canActivate: [AuthGuard],
                    //  data: { title: "Bluetooth locks", toolTip: "My bluetooth locks", roles: ['OneWayAdmin', 'LocationManager', 'GroupManager'], icon: 'lock' },
                    //  children: [
                    //    { path: '', redirectTo: 'ManageLocks', pathMatch: 'full' },
                    //    {
                    //      path: "ManageLocks",
                    //      canActivate: [AuthGuard],
                    //      component: LocksComponent,
                    //      data: { title: "Manage locks", roles: ['OneWayAdmin', 'LocationManager', 'GroupManager'], icon: 'lock' }
                    //    }
                    //  ]
                    //},
                ]
            },
        ])
    ],
    providers: [T4CommonModule]
})
export class FleetManagement {
    public static theme: string = "unicorn-dark-theme";
}
